import React, { Component } from 'react';
import { Card, CardBody, Button, Modal, ModalHeader, ModalBody, Col, Row, CardFooter } from 'reactstrap'
import mostrarImg from '../../Img/document.png'
import history from '../../historial'
import Fetch from '../../Auxiliares/fetch'
import { toast } from 'react-toastify'
import pdf from '../../Img/Iconos/pdf.png'
import {ip} from '../../Auxiliares/ip'
import '../../CSS/style.css'
import SideBar from '../../Img/SideBar.png'

export default class consultaCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isViewOpen: null,
            isShowModalOpen: null,
            documentos: []
        }

        this.toggleShow = this.toggleShow.bind(this)
        this.toggleAndFetch = this.toggleAndFetch.bind(this)
        this.FetchDocumentosEstudiante = this.FetchDocumentosEstudiante.bind(this)
        this.agregar = this.agregar.bind(this)
    }

    agregar(){
        history.push({
            pathname: `/digitalizar/${this.props.noControl}`
            }
        )
        /*sessionStorage.setItem("fromConsulta", this.props.noControl);
        history.push({
            pathname: '/digitalizar', 
            search: `=${this.props.noControl}`
        })*/

    }
     
    toggleView(obj) {
        this.setState(prevState => ({
            isViewOpen: obj ? obj : null
        })
        )
    }

    toggleAndFetch(props){
        this.FetchDocumentosEstudiante(props.noControl)
        this.toggleShow(props)
    }

    FetchDocumentosEstudiante(noControl){
        Fetch('/api/getDocumentos', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ noControl })
        })
            .then(response => {
                this.setState({ documentos: response.data })
            })
            .catch(err => {
                switch (err.status) {

                    case 602:
                        toast.error('No existen datos correspondientes')
                        break;

                    case 605:
                        this.setState({ documentos: [] })
                        break;

                    default:
                        toast.error(err)
                        break;
                }
            })
    }

    toggleShow(obj) {
        this.setState({
            isShowModalOpen: obj ? obj : null
        })
    }

    render() {
        return (
            <div className="col-12">
                <Card className={this.props.encabezado ? "mb-1 col-12 py-2 bg-secondary text-white" : "mb-1 col-12 py-2"}>
                    <Row className="p-1 col-12 mx-1">
                        <Col md="12 font-weight-bold" lg="2"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "No. Control" : this.props.noControl}</Col>
                        <Col md="12" lg="3"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Nombre" : this.props.nombre + ' ' + this.props.ap_paterno + ' ' + this.props.ap_materno}</Col>
                        <Col md="12" lg="4"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Carrera" : this.props.carrera}</Col>
                        <Col md="12" lg="2"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Semestre" : this.props.semestre}</Col>
                        <Col md="12" lg="1">{this.props.encabezado ? <div /> : <img className="img-responsive clicable" alt="mostrar imagen" width="20em" src={mostrarImg} onClick={() => this.toggleAndFetch(this.props)} />}</Col>
                    </Row>
                </Card>

                <Modal isOpen={this.state.isShowModalOpen !== null} toggle={() => this.toggleShow()}
                    className="modal-xl">
                    <ModalHeader toggle={() => this.toggleShow()}>Documentos de: {this.props.nombre} {this.props.ap_paterno} {this.props.ap_materno} ({this.props.noControl})</ModalHeader>
                    <ModalBody>
                        <Row>
                            {this.state.documentos.length > 0 ? this.state.documentos.map((index) =>
                                <Col lg="4" md="6" xs="6">
                                    <div>
                                        <Card className="mb-2 text-center clicable list-group-item" style={{ height:'auto'}} onClick={()=>this.toggleView(index)} > 
                                            <CardBody className="text-center">
                                                <img alt="icono pdf" src={pdf} width="30%"/>
                                            </CardBody>

                                            <CardFooter className="text-center bg-dark text-light">
                                                {index.nombre}
                                            </CardFooter>
                                        </Card>
                                    </div>
                                </Col>
                            ) : <Col><Card className="d-flex p-5 text-center bg-secondary text-light shadow " style={{ border: 'dashed 2px' }} >Lista vacia</Card></Col> }
                        </Row>
                    </ModalBody>
                        <Button onClick={this.agregar} className="list-group-item"
                        style={{background:`url(${SideBar})`, backgroundSize:'cover', backgroundPosition:'center'}}
                        >Agregar documento</Button>
                </Modal>

                <Modal className="pt-5 modal-xl" isOpen={this.state.isViewOpen !== null} toggle={() => this.toggleView()}>
                    <ModalHeader toggle={() => this.toggleView()} className="font-weight-bold">{this.state.isViewOpen != null ? this.state.isViewOpen.nombre : ''}</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="border-0">
                                    <Row>
                                        <Col className="text-center">
                                            <iframe
                                                title="PDF viewer"
                                                width="100%" 
                                                height="625"
                                                src={this.state.isViewOpen != null ? ip +this.state.isViewOpen.ruta : 'none'}>
                                            </iframe>
                                        </Col>
                                    </Row>

                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

            </div>
        )
    }
}